import React from 'react';
import moment from 'moment';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';

export const DeadlineTooltip = ({ ticket }) => {
  const deadline = ticket.order_data?.complementary_info?.customer_deadline;

  const head = 'Deadline';
  const body = deadline ? moment(deadline).format('MMM DD/YYYY - HH:mm') : 'Not Defined';
  return (
    <>
      <TooltipHeader>{head}</TooltipHeader>
      <TooltipBody>{body}</TooltipBody>
    </>
  );
};
